import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import React from 'react';
import ReactDOM from 'react-dom';

import {
  BrowserRouter as Router,
} from "react-router-dom";
import NofeshService from './services/Nofesh.service'
import {NofeshServiceProvider} from './context/AppProvider.context'
import App from './App';


const nofeshService = new NofeshService();


ReactDOM.render(
  <React.StrictMode>
      <NofeshServiceProvider value={nofeshService}>
        <Router basename={window.NOFESH_PUBLIC_URL}>  
          <App />
        </Router>
      </NofeshServiceProvider>
  </React.StrictMode>,
  document.getElementById('root')
);